import React from 'react';
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function FlowSettings() {
    const [flowSettings, setFlowSettings] = React.useState({
        flow_id: "",
        flow_cta: "",
        flow_mode: "",
        flow_header: "",
        flow_body: ""
    });
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axiosPrivate.post("/flow_settings", flowSettings, {headers: {Authorization: "Bearer " + auth.accessToken}});
        } catch(err) {
            console.log(err);
        }
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setFlowSettings(prevSettings => ({
            ...prevSettings,
            [name]: value
        }));
    }

    return (
        <form onSubmit={handleSubmit}>
            <select 
                id="flow_mode"
                name="flow_mode"
                value={flowSettings.flow_mode}
                onChange={onChange}
                required
                className="w-auto px-4 py-2 mb-4 text-sm text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
                <option value="">Choose mode</option>
                <option value="draft">Draft</option>
                <option value="published">Published</option>
            </select>
            <input
                type="text"
                id="flow_id"
                name="flow_id"
                autoComplete="off"
                onChange={onChange}
                value={flowSettings.flow_id}
                required
                placeholder="Flow ID"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <input
                type="text"
                id="flow_cta"
                name="flow_cta"
                autoComplete="off"
                onChange={onChange}
                value={flowSettings.flow_cta}
                required
                placeholder="Flow Call to Action"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <textarea
                id="flow_header" 
                name="flow_header" 
                onChange={onChange} 
                value={flowSettings.flow_header}
                placeholder="Flow Header"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4 h-32"
                rows={5}
                required
            />
            <textarea
                id="flow_body" 
                name="flow_body" 
                onChange={onChange} 
                value={flowSettings.flow_body}
                placeholder="Flow Body"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4 h-32"
                rows={5}
                required
            />
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    )
}

export default FlowSettings;